/**
 * OrderHistory.Collection.Ext.js
 *
 * Purchase History without rental orders. Points the native OrderHistory
 * collection at the RentFromAnywhere service (mode=orders), which proxies the
 * SL_Get_Rentals Suitelet: same JSON shape as OrderHistory.Service.ss
 * ({ records, totalRecordsFound, recordsPerPage, page }) but excluding
 * NetScore rental Sales Orders (form 229) and cancelled rental-only web orders.
 * The native sort / order / from / to / filter / page params are forwarded, so
 * the list header (date range, sort, Open / In Store tabs) keeps working.
 * No theme change needed: url() is the only thing overridden.
 */
define("OrderHistory.Collection.Ext", [
  "OrderHistory.Collection",
  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",
  "underscore"
], function (OrderHistoryCollection, RentFromAnywhereSS2Model, _) {
  "use strict";

  var serviceUrl = RentFromAnywhereSS2Model.prototype.urlRoot;

  OrderHistoryCollection.prototype.url = function () {
    return serviceUrl + (serviceUrl.indexOf("?") > -1 ? "&" : "?") + "mode=orders";
  };

  // Native parse already reads records / totalRecordsFound / recordsPerPage,
  // but be defensive in case the response is the bare array.
  var originalParse = OrderHistoryCollection.prototype.parse;
  OrderHistoryCollection.prototype.parse = function (response) {
    if (response && _.isArray(response.records)) {
      this.totalRecordsFound = response.totalRecordsFound;
      this.recordsPerPage = response.recordsPerPage;
      return response.records;
    }
    return originalParse ? originalParse.apply(this, arguments) : response;
  };

  return OrderHistoryCollection;
});
